import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FaceRetouchingOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"face_retouching_off"}/>
}
